// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"3b954f94","787":"78b0654a"}[chunkId] + ".chunk.js";
};